import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/small-thumb-1-risk.webp")